export default "__VITE_ASSET__8f188ba4__"